import { OVERLAY_DEFAULT_CONFIG, OverlayDefaultConfig } from '@angular/cdk/overlay';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { enableProdMode, ErrorHandler, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideEnv } from '@evc/platform';

import { RELEASE_NOTE_TOKEN } from '@olympus/ngx-shared';

import { AppComponent } from './app/app.component';
import { AppModule } from './app/app.module';
import { appInitializerConfig } from './app/app-initializer.config';
import { appInterceptor } from './app/app-interceptor.config';
import { preferenceProviders } from './app/app-preference.config';
import { storeProviders } from './app/app-store.config';
import { ErrorHandlerService } from './app/core/services/error-handler/error-handler.service';
import { sharedModulesProviders, sharedModulesWithProviders } from './app/shared-modules.lib';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    {
      provide: OVERLAY_DEFAULT_CONFIG,
      useValue: { usePopover: false } satisfies OverlayDefaultConfig,
    },
    { provide: ErrorHandler, useClass: ErrorHandlerService },
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      AppModule,
      ...sharedModulesWithProviders,
    ),
    { provide: 'environment', useValue: environment },
    environment.USE_CONNECT_PLATFORM && environment.cloudConnected ? provideEnv(environment) : [],
    { provide: RELEASE_NOTE_TOKEN, useValue: '/assets/releasenotes.json' },
    ...preferenceProviders,
    ...storeProviders,
    ...[environment.USE_CONNECT_PLATFORM ? [] : appInterceptor],
    ...sharedModulesProviders,
    ...appInitializerConfig, // Should always be at the end of providers list
  ],
}).catch(err => console.error(err));
